import { DefaultFetchService } from "app/services/fetchService";
import type {
    IBaseColumn,
    IFilters } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/types";
import {
    EIndustriesType
} from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/types";
import type { CategoryId } from "app/common/services/categoryService.types";
import categoryService from "app/common/services/categoryService";
import type { IBaseRecord } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/getTableData";
import { getQueryParams } from "app/pages/industry-analysis/common/getQueryParams";

const EXCEL_ENDPOINT = "api/Industries/Benchmark/Excel";

type IApiFields = Record<keyof IBaseRecord, keyof IBaseColumn>;

const API_FIELDS: IApiFields = {
    industry: "Category",
    totalVisits: "AvgVisits",
    uniqueVisitors: "AvgUnique",
    totalVisitsChange: "VisitsChange",
    uniqueVisitorsChange: "UniqueChange",
    previousPeriodTotalVisits: "PrevAvgVisits",
    previousPeriodUniqueVisitors: "PrevAvgUnique",
};

export const getExcelLink = (filters: IFilters, favorites: Array<CategoryId>) => {
    const { search, isFavorites, sort, selectedIndustry, industriesType } = filters;
    const { sortDirection, field } = sort;
    const fetcherService = DefaultFetchService.getInstance();
    const baseParams = getQueryParams();
    const queryParams = { ...baseParams, includeMainOnly: industriesType === EIndustriesType.MAIN };
    if (sortDirection && field) {
        queryParams["orderBy"] = `${API_FIELDS[field]} ${sortDirection}`;
    }
    if (search) {
        queryParams["filter"] = `${API_FIELDS.industry};contains;"${search?.trim()}"`;
    }
    if (isFavorites) {
        const industries = favorites.map((categoryId) => {
            const category = categoryService.getCategory(categoryId);
            return category.forApi;
        });
        queryParams["industries"] = industries.join();
    }

    const { children } = selectedIndustry;
    const selectedIndustryIsChild = children === undefined;
    const selectedIndustryHasChildren = children?.length > 0;
    if (selectedIndustryHasChildren) {
        queryParams["mainIndustry"] = selectedIndustry.forApi;
    }
    if (selectedIndustryIsChild) {
        const flattenSelectedIndustry = categoryService
            .getFlattenedCategoriesList()
            .find((industry) => industry.id === selectedIndustry.id);
        queryParams["mainIndustry"] = flattenSelectedIndustry.parentItem.forApi;
    }
    const excelLink = `${EXCEL_ENDPOINT}?${fetcherService.requestParams(queryParams)}`;
    return excelLink;
};
